// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"25":"e8eb08c4","258":"d493fb1a","744":"a539ff81","791":"4b5881ee"}[chunkId] + ".js";
};